// Mix of guest and landlord reviews with avatar images
const reviews = [
  {
    quote: "Moved abroad for work and didn't want the hassle of letting. Truestays handles everything and I'm making way more than my old AST rent.",
    name: "Cara M",
    role: "Landlord",
    type: "landlord",
    avatar: "https://randomuser.me/api/portraits/women/44.jpg",
  },
  {
    quote: "Place was exactly as pictured. Self check-in worked perfectly and the flat was spotless. Would definitely stay again.",
    name: "James R",
    role: "Guest · Manchester",
    type: "guest",
    avatar: "https://randomuser.me/api/portraits/men/32.jpg",
  },
  {
    quote: "Was sceptical at first but they proved themselves quickly. My income's up about 40% and I don't lift a finger.",
    name: "Sarah K",
    role: "Landlord, Portfolio owner",
    type: "landlord",
    avatar: "https://randomuser.me/api/portraits/women/68.jpg",
  },
  {
    quote: "Used to get £950 a month on a long-term let. Now averaging over £2k on Airbnb. Best decision I made.",
    name: "Michael T",
    role: "Landlord",
    type: "landlord",
    avatar: "https://randomuser.me/api/portraits/men/45.jpg",
  },
  {
    quote: "Lovely apartment in a great spot. Really clean and the local guide they sent was super helpful for finding restaurants.",
    name: "Emma L",
    role: "Guest",
    type: "guest",
    avatar: "https://randomuser.me/api/portraits/women/33.jpg",
  },
  {
    quote: "They got me listed within a week and the bookings started coming straight away. Proper professional team.",
    name: "David P",
    role: "Landlord",
    type: "landlord",
    avatar: "https://randomuser.me/api/portraits/men/51.jpg",
  },
  {
    quote: "Had a small issue with the heating and they sorted it out same day. Great communication throughout our stay.",
    name: "Rachel N",
    role: "Guest",
    type: "guest",
    avatar: "https://randomuser.me/api/portraits/women/26.jpg",
  },
  {
    quote: "Honestly wasn't sure about short-lets but the income difference is massive. No more rent arrears worries either.",
    name: "Tom H",
    role: "Landlord",
    type: "landlord",
    avatar: "https://randomuser.me/api/portraits/men/75.jpg",
  },
];

// Deliberately staggered - not all perfectly aligned
const col1 = [reviews[0], reviews[3], reviews[6]];
const col2 = [reviews[1], reviews[4], reviews[7]];
const col3 = [reviews[2], reviews[5]];

function StarRow() {
  return (
    <div style={{ display: "flex", gap: 2, marginBottom: 10 }}>
      {[1,2,3,4,5].map(i => (
        <svg key={i} width="13" height="13" viewBox="0 0 24 24" fill="#FBBF24" stroke="#FBBF24" strokeWidth="1.5">
          <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
        </svg>
      ))}
    </div>
  );
}

function ReviewCard({ r, nudge = 0 }) {
  const isGuest = r.type === "guest";
  return (
    <div
      style={{
        background: "#fff",
        border: "1px solid #EBEBEB",
        borderRadius: 14,
        padding: "20px 20px",
        marginBottom: 14,
        marginTop: nudge,
        transition: "box-shadow 0.2s",
      }}
      onMouseEnter={e => e.currentTarget.style.boxShadow = "0 8px 28px rgba(0,0,0,0.07)"}
      onMouseLeave={e => e.currentTarget.style.boxShadow = "none"}
    >
      <p style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 13.5, color: "#222", lineHeight: 1.65, margin: "0 0 16px 0" }}>"{r.quote}"</p>
      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
        <img src={r.avatar} alt={`${r.name} - Truestays ${r.type === 'guest' ? 'guest' : 'landlord'} review`} style={{ width: 34, height: 34, borderRadius: "50%", objectFit: "cover", flexShrink: 0 }} loading="lazy" decoding="async" />
        <div>
          <p style={{ fontFamily: "'DM Sans', sans-serif", fontWeight: 600, fontSize: 12.5, color: "#1A1A1A", margin: 0 }}>{r.name}</p>
          <p style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 11, color: "#888", margin: "2px 0 0" }}>{r.role}</p>
        </div>
        <div style={{ marginLeft: "auto" }}>
          {isGuest ? (
            <span style={{ fontSize: 10, fontWeight: 600, color: "#FF5A5F", background: "#FFF0F0", borderRadius: 100, padding: "2px 8px", fontFamily: "'DM Sans', sans-serif" }}>Guest</span>
          ) : (
            <span style={{ fontSize: 10, fontWeight: 600, color: "#16a34a", background: "#f0fdf4", borderRadius: 100, padding: "2px 8px", fontFamily: "'DM Sans', sans-serif" }}>Landlord</span>
          )}
        </div>
      </div>
    </div>
  );
}

export default function ReviewsSection() {
  return (
    <section style={{
      backgroundColor: "#fff",
      paddingTop: "clamp(60px, 7vw, 96px)",
      paddingBottom: "clamp(60px, 7vw, 96px)",
      paddingLeft: "clamp(16px, 5vw, 80px)",
      paddingRight: "clamp(16px, 5vw, 80px)",
    }}>
      <div style={{ maxWidth: 1200, margin: "0 auto" }}>
        <div style={{ textAlign: "center", marginBottom: 56 }}>
          <p style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 13, fontWeight: 600, color: "#888", marginBottom: 10, marginTop: 0 }}>
            TRUSTED BY GUESTS AND LANDLORDS
          </p>
          <h2 style={{ fontFamily: "'Inter', sans-serif", fontWeight: 700, fontSize: "clamp(28px, 4vw, 48px)", letterSpacing: "-0.02em", color: "#1A1A1A", lineHeight: 1.1, marginBottom: 14, marginTop: 0 }}>
            We've got the reviews.
          </h2>
          <div style={{ display: "flex", gap: 20, justifyContent: "center", alignItems: "center", flexWrap: "wrap" }}>
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <div style={{ display: "flex", gap: 2 }}>
                {[1,2,3,4,5].map(i => (
                  <svg key={i} width="14" height="14" viewBox="0 0 24 24" fill="#FBBF24" stroke="#FBBF24" strokeWidth="1.5">
                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                  </svg>
                ))}
              </div>
              <span style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 13, color: "#555", fontWeight: 600 }}>5.0 on Google (90+ reviews)</span>
            </div>
            <span style={{ color: "#D5D5D5" }}>·</span>
            <span style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 13, color: "#555", fontWeight: 600 }}>4.76 on Airbnb (1,000+ reviews)</span>
          </div>
        </div>

        {/* Staggered masonry - col2 offset slightly down */}
        <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 14, alignItems: "start" }} className="reviews-masonry">
          <div>{col1.map((r, i) => <ReviewCard key={i} r={r} nudge={0} />)}</div>
          <div style={{ marginTop: 28 }}>{col2.map((r, i) => <ReviewCard key={i} r={r} />)}</div>
          <div>{col3.map((r, i) => <ReviewCard key={i} r={r} nudge={0} />)}</div>
        </div>
      </div>

      <style>{`
        @media (max-width: 768px) { .reviews-masonry { grid-template-columns: 1fr !important; } .reviews-masonry > div { margin-top: 0 !important; } }
        @media (min-width: 769px) and (max-width: 1000px) { .reviews-masonry { grid-template-columns: repeat(2, 1fr) !important; } }
        @media (max-width: 480px) {
          .reviews-masonry { gap: 10px !important; }
          section { padding-left: 16px !important; padding-right: 16px !important; }
        }
      `}</style>
    </section>
  );
}